import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';

const fmt=(v)=>v?new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',year:'numeric'}).format(new Date(v)):'—';
function remaining(v){
  const ms=new Date(v).getTime()-Date.now();
  if(ms<=0)return 'Restore window expired';
  const days=Math.ceil(ms/86400000);
  return `${days} day${days===1?'':'s'} remaining`;
}

export default function TrashPage(){
  const {workspace}=useAuth();
  const [rows,setRows]=useState([]),[message,setMessage]=useState(''),[busy,setBusy]=useState('');
  async function load(){
    const {data,error}=await supabase.from('leads').select('id,name,instagram_handle,deleted_at,purge_after').eq('workspace_id',workspace.id).not('deleted_at','is',null).order('deleted_at',{ascending:false});
    if(error)setMessage(error.message);else setRows(data??[]);
  }
  useEffect(()=>{load();},[workspace.id]);
  async function restore(id){
    setMessage('');setBusy(id);
    const {error}=await supabase.rpc('restore_lead',{p_lead_id:id});
    setBusy('');
    if(error)setMessage(error.message);else{setMessage('Lead restored to Active.');load();}
  }
  return <section className="page-stack">
    <div><h1 className="page-title">Trash</h1><p className="page-description">Only accidental entries belong here. Real sales history must be Archived instead.</p></div>
    <div className="trash-policy panel"><strong>7-day recovery</strong><span>Trashed Leads disappear from normal lists and metrics immediately. Eligible entries can be restored until their recovery window expires.</span></div>
    {message&&<div className="info-message">{message}</div>}
    <div className="panel">{rows.length===0?<div className="empty-state"><strong>Trash is empty.</strong></div>:rows.map(row=><div className="trash-row" key={row.id}>
      <div><strong>{row.name}</strong><span>{row.instagram_handle||'No Instagram handle'}</span><small>Deleted {fmt(row.deleted_at)} · {remaining(row.purge_after)}</small></div>
      <button className="secondary-button" disabled={busy===row.id||new Date(row.purge_after).getTime()<=Date.now()} onClick={()=>restore(row.id)}>{busy===row.id?'Restoring…':'Restore'}</button>
    </div>)}</div>
  </section>;
}
